import { cva } from '@/styled-system/css';

export const popoverBackdropRecipe = cva({
  variants: {
    modal: {
      true: {
        display: 'grid',
        placeItems: 'center',
        zIndex: 'popover',
        animation: 'fade 0.2s ease-out',
        blockSize: 'auto',
        maxBlockSize: 'none',
        inlineSize: 'auto',
        maxInlineSize: 'none',
        paddingBlock: 'layout.looser',
        paddingInline: 'layout.tight',

        _before: {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundColor: 'bg.screen.scrim',
          opacity: 'dialogScrim',
          zIndex: 1,
          isolation: 'isolate',
        },
      },
      false: {},
    },
  },
});
